export default function drawDiamond(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  slope: number,
  stroke = false,
) {
  ctx.beginPath()
  ctx.moveTo(x + w + slope, y)
  ctx.lineTo(x + w, y + h)
  ctx.lineTo(x, y + h)
  ctx.lineTo(x + slope, y)
  ctx.closePath()
  ctx.fill()
  if (stroke) {
    ctx.stroke()
  }
}
